//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Enums } from "../../../models/common"
import { OpTariff } from "../../../models/core"
import { IOpObject } from "../../../models/util/interfaces"

import { EventsNames, LocalizationHelper, CommonHelper, TypeHelper, LogHelper } from "../../../helpers"
import { PopupType } from "../../../helpers/popup-manager"
import { TariffService } from '../../../services/tariff'
import { UserSessionService } from '../../../services/user-session'

import { CreateEditController, CreateEditScope } from "../../common/common.create-edit.controller"
import { LoggerService } from "../../common/common.module"
import { CreateEditInitParams, BulkEditInitParams } from "../../common/create-edit-popup/create-edit-popup.controller"
import { TariffCopySummaryOptions } from '../components/tariff-copy-summary/tariff-copy-summary.controller'

interface TariffCreateEditScope extends CreateEditScope {
    isCopy: boolean
    tariffCopySummaryOptions: TariffCopySummaryOptions
}

export class TariffCreateEditController extends CreateEditController {

    // #region Members

    private referenceValue: OpTariff

    // #endregion


    // #region Ctor

    constructor(
        private $scope: TariffCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSessionService: UserSessionService,
        private tariffService: TariffService,
        private referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Events

     private onInit(args: any[]): void {
        if (_.size(args) > 0 && args[0] != null) {
            const createEditInitParams: CreateEditInitParams = args[0]
            this.$scope.isCopy = createEditInitParams.isCopy

            this.referenceValue = createEditInitParams != null && createEditInitParams.referenceObject != null ? (<OpTariff>createEditInitParams.referenceObject).clone(true, true, true) : null

            if (createEditInitParams.isCopy === true) {
                createEditInitParams.referenceObjectId = 0
                if (createEditInitParams.referenceObject != null) {
                    createEditInitParams.referenceObject.idObject = 0
                }
            }

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.$scope.isCopy) {
                this.$scope.options.title = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TariffCopy)
            } else if (this.referenceValue != null && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onInitBulk(args: any[]): void {
        if (_.size(args) > 0 && args[0] != null) {
            const bulkEditInitParams: BulkEditInitParams = args[0]
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
            this.$scope.gridData = args[0]
            if (args[1] != null) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const tariff: OpTariff = OpTariff.fromIOpObject(objectToSave)

        if (this.referenceValue != null) {
            tariff.idDistributor = this.referenceValue.idDistributor
            const idDistributor: number = tariff.dataList.getValue(Enums.DataType.HELPER_ID_DISTRIBUTOR)
            if (idDistributor == null) {
                if (this.referenceValue != null) {
                    tariff.dataList.setValue(this.referenceValue.dataList.getValue(Enums.DataType.HELPER_ID_DISTRIBUTOR), Enums.DataType.HELPER_ID_DISTRIBUTOR)
                }
            }
        }

        if (this.$scope.isCopy) {
            this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR) //needs to hide loading indicator called in create-edit-popup     
            const summaryDeferred: JQueryDeferred<OpTariff> = $.Deferred()

            this.$scope.tariffCopySummaryOptions = {
                deferred: summaryDeferred,
                copyFrom: this.referenceValue,
                copyTo: tariff
            }

            summaryDeferred.then((savedObject: OpTariff) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
                .fail((error: any) => {
                    deferred.reject(error)
                })
        } else {
            this.tariffService
                .saveTariff(tariff, this.moduleName)
                .then((savedObject: OpTariff) => {
                    this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                    deferred.resolve(savedObject)
                })
                .fail((error: any) => {
                    deferred.reject(error)
                })
        }

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const tariff: OpTariff = OpTariff.fromIOpObject(objectToSave)

        tariff.opState = Enums.OpChangeState.Modified

        this.tariffService
            .saveTariff(tariff, this.moduleName, true)
            .then((savedObject: OpTariff) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                LogHelper.error(TariffService.LOG_PREFIX, error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    // #endregion


    // #region Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => { this.onInit(args) }
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => { this.onInitBulk(args) }
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.tariffSaved,
            onSubmit: null,
            onClose: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: TypeHelper.emptyString,
            type: null,

            onBulkSave: (objectToSave: IOpObject) => { return this.onBulkSave(objectToSave) },
            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
        }
    }

    // #endregion
}